import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconCareerActiveSvg } from "./IconCareerActiveSvg.mjs";
import { IconCareerSvg } from "./IconCareerSvg.mjs";
const IconCareer = ({ active = false, ...props }) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(
  Box,
  {
    component: active ? IconCareerActiveSvg : IconCareerSvg,
    ...svgProps
  }
) });
export {
  IconCareer
};
